/* RESPONSIBLE TEAM: team-fin-voice */
import Step, { IsCustomerFacing } from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import type ConnectionPoint from '../connection-point';
import { buildValidations, validator } from 'ember-cp-validations';
import { attr } from '@ember-data/model';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { not } from '@ember/object/computed';

const Validations = buildValidations({
  outwardConnectionPoints: [validator('has-many')],
  hasAiContentReadyForFin: {
    descriptionKey: 'ai-agent.profiles.validation-errors.ai-content-not-ready',
    validators: [
      validator('fin-has-ai-content-ready', {
        disabled: not('model.useAiAnswers'),
      }),
    ],
    dependentKeys: [
      'model.useAiAnswers',
      'model.app.isStandaloneApp',
      'model.app.usesResolutionsWithCustomAnswers',
      'model.contentImportService.aiContentLibrarySummary',
      'model.finStandaloneService.isLoadingAiContentLibrarySummary',
      'model.customAnswerCount',
    ],
  },
  finVoiceNumberConfigurationId: [
    validator('presence', {
      presence: true,
    }),
  ],
});

export default class FinVoice extends Step.extend(Validations) {
  @attr('string') declare finVoiceNumberConfigurationId: string;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.finVoice;
  }

  static get isStepGroupEnding() {
    return true;
  }

  static get canBeCustomerFacing() {
    return IsCustomerFacing.Yes;
  }

  static get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  static createNewStep(store: Store): FinVoice {
    let outwardConnectionPoints = [
      store.createRecord('operator/visual-builder/connection-point', { type: 'fin_triage' }),
    ] as ConnectionPoint[];

    return store.createRecord('operator/visual-builder/step/fin-voice', {
      type: 'operator/visual-builder/step/fin-voice',
      outwardConnectionPoints,
    });
  }
}
